import styled from "styled-components";
import React, {useState} from "react";
import {schemas} from "../../config";
import Loader from "../../components/Loader";
import {LoaderContainer} from "../../components/table/Table";
import {toast} from "react-toastify";
import {useAppDispatch} from "../../hooks";
import {fetchTableByQuery} from "../../features/tableSlice";

let initialState = {
    name: '',
};

function CreateExtraActivation() {
    const [extraActivation, setExtraActivation] = useState<{ [key: string]: any }>(initialState)
    const [fetching, setFetching] = useState('idle')

    const changeValue = (name: string, value: string, type = 'string') => {
        let newValue: string | number = value;
        if (type === 'number' && value !== '') {
            const parsedValue = parseFloat(value);
            newValue = (isNaN(parsedValue) ? 0 : parsedValue);
        }
        setExtraActivation(state => ({
            ...state,
            [name]: newValue
        }))
    }

    const dispatch = useAppDispatch();

    const createExtraActivation = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        let init: RequestInit = {
            method: "POST",
            body: JSON.stringify(extraActivation),
            credentials: 'include'
        };

        setFetching('loading')
        fetch(schemas['act287'].backend + '/287/createExtraActivation.php', init)
            .then(r => r.json())
            .then(r => {
                if (r.status === 'success') {
                    toast.success(r.message)
                    setExtraActivation(initialState)
                    dispatch(fetchTableByQuery({clean: true, pageIndex: 1}))
                } else
                    toast.error(r.message)
                setFetching('idle')
            })
            .catch(e => {
                toast.error(e)
                setFetching('idle')
            })
    }

    const renderInputs = () =>
        schema.map(({name, type, label, required}) => (
            <div key={name} className="form-field">
                <label htmlFor={name}>
                    {label} {required ? '*' : ''}
                </label>
                {type === 'textarea' && <textarea
                    style={{width: '100%', textIndent: '0'}}
                    rows={20}
                    id={name}
                    name={name}
                    placeholder={label}
                    value={extraActivation[name]}
                    onChange={(e) => changeValue(name, e.currentTarget.value, type)}
                    required={required}
                />}
                {type !== 'textarea' && <input
                    id={name}
                    name={name}
                    type={type}
                    placeholder={label}
                    value={extraActivation[name]}
                    onChange={(e) => changeValue(name, e.currentTarget.value, type)}
                    required={required}
                />}

            </div>
        ));


    return <Container>
        <h3>Створити нову доп активацію</h3>
        <form onSubmit={e => createExtraActivation(e)}>
            <fieldset>
                <legend>Нова доп. активація</legend>
                {renderInputs()}
                <div className={'create-btn'}>
                    <button type={'submit'} disabled={fetching === 'loading'}>Створити</button>
                </div>
            </fieldset>
        </form>
        {fetching === 'loading' && <LoaderContainer>
            <Loader/>
        </LoaderContainer>}
    </Container>
}

export default CreateExtraActivation

const Container = styled.section`
    margin-top: .5rem;
    margin-left: auto;
    margin-right: auto;
    color: var(--table-row-text-color);
    display: flex;
    flex-flow: column;
    gap: .5rem;
    max-width: 800px;
    padding: .5rem;
    background: var(--table-row-odd-bg-color);
    border-radius: .5rem;

    position: relative;

    & h3 {
        text-align: center;
        font-size: 1.6rem;
        font-weight: bold;
    }

    & fieldset {
        margin-inline: 2px;
        padding-block: 0.35em 0.625em;
        padding-inline: 0.75em;
        border: 2px groove ThreeDFace;
        border-radius: .5rem;
        min-inline-size: min-content;
        display: flex;
        flex-flow: column;

        & legend {
            background-color: #000;
            color: #fff;
            padding: 3px 6px;
        }

        & .create-btn {
            display: flex;
            justify-content: center;
            margin-top: .5rem;

            & button {
                max-width: 300px;
                width: 100%;
                padding: .4rem;
                border-radius: .2rem;
                background-color: var(--table-action-color);
                cursor: pointer;
                color: var(--table-row-text-color);
                border: none;
                font-size: 1rem;
                font-weight: bold;

                &:hover {
                    filter: brightness(.85);
                }
            }
        }

    }

    & .form-field {

        display: flex;
        flex-wrap: wrap;
        gap: .5rem;
        font-size: 1rem;
        font-weight: bold;
        align-items: center;
        padding: .5rem 0;
        border-bottom: 2px solid var(--table-border-color);

        & label {
            flex-basis: 150px;
        }

        & input {
            flex-grow: 1;
            min-width: 280px;
            padding: .2rem;
            font-size: 1rem;

            &[type='datetime-local'] {
                flex-grow: 0;
                width: 230px;
                min-width: 230px;
            }

        }
    }



`

const schema = [
    {
        name: 'name',
        type: 'text',
        label: 'Назва(зазвичай у форматі деньмісяцьрік):',
        required: true,
    }
];
